// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorial-container {
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  background-color: transparent;
  text-align: center;
  cursor: pointer;
  transition: bottom 0.5s ease-in-out;
  z-index: 9999;
}

.tutorial-container.expanded {
  bottom: 0;
  background-color: var(--secondary-background);
  width: 100%;
  max-height: calc(100vh - 64px - 8rem); /* viewport height - navbar - padding */
  left: 0;
  top: 0;
  transform: none;
  overflow: auto;
}

.tutorial-arrow {
  font-size: 2em;
}

.tutorial-text {
  font-size: 1.2em;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.hide-arrow, .hide-text {
  display: none;
}

.tutorial-content {
  display: none;
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--background);
  padding: 8px;
  border-radius: 5px;
}

.tutorial-container.expanded .tutorial-content {
  display: block;
}

.tutorial-toggle {
  cursor: pointer;
}

.bottom-container {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  cursor: pointer;
}

.tutorial-video {
  height: 400px;
  width: 85vw;
  max-width: 960px;
  border-radius: 5px;
}


.tutorial-content button {
  font-weight: bold;
  border: none;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
  padding: 12px;
  margin: 12px 12px;
  border-radius: 8px;
  text-align: center;
  width: 40%;
  background-color: var(--theme-consistent);
  color: white;
  font-size: 1rem;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.tutorial-content button:active {
  transform: scale(0.98);
  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
}

.tutorial-content button:disabled {
  opacity: 0.5;
}

/* Adjust the height of the video on smaller screens */
@media screen and (max-width: 375px) {
  .tutorial-video {
    height: 200px;
  }

  .tutorial-text {
    font-size: 1em;
  }

  .tutorial-arrow {
    font-size: 1.5em;
  }

  .tutorial-content {
    padding: 4px;
  }

  .tutorial-content button {
    font-size: 0.8rem;
    padding: 8px;
    margin: 8px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Tutorial.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,6CAA6C;EAC7C,WAAW;EACX,qCAAqC,EAAE,uCAAuC;EAC9E,OAAO;EACP,MAAM;EACN,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".tutorial-container {\n  position: fixed;\n  bottom: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: transparent;\n  text-align: center;\n  cursor: pointer;\n  transition: bottom 0.5s ease-in-out;\n  z-index: 9999;\n}\n\n.tutorial-container.expanded {\n  bottom: 0;\n  background-color: var(--secondary-background);\n  width: 100%;\n  max-height: calc(100vh - 64px - 8rem); /* viewport height - navbar - padding */\n  left: 0;\n  top: 0;\n  transform: none;\n  overflow: auto;\n}\n\n.tutorial-arrow {\n  font-size: 2em;\n}\n\n.tutorial-text {\n  font-size: 1.2em;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.hide-arrow, .hide-text {\n  display: none;\n}\n\n.tutorial-content {\n  display: none;\n  position: absolute;\n  top: 42%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--background);\n  padding: 8px;\n  border-radius: 5px;\n}\n\n.tutorial-container.expanded .tutorial-content {\n  display: block;\n}\n\n.tutorial-toggle {\n  cursor: pointer;\n}\n\n.bottom-container {\n  position: absolute;\n  bottom: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  cursor: pointer;\n}\n\n.tutorial-video {\n  height: 400px;\n  width: 85vw;\n  max-width: 960px;\n  border-radius: 5px;\n}\n\n\n.tutorial-content button {\n  font-weight: bold;\n  border: none;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n  padding: 12px;\n  margin: 12px 12px;\n  border-radius: 8px;\n  text-align: center;\n  width: 40%;\n  background-color: var(--theme-consistent);\n  color: white;\n  font-size: 1rem;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.tutorial-content button:active {\n  transform: scale(0.98);\n  box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);\n}\n\n.tutorial-content button:disabled {\n  opacity: 0.5;\n}\n\n/* Adjust the height of the video on smaller screens */\n@media screen and (max-width: 375px) {\n  .tutorial-video {\n    height: 200px;\n  }\n\n  .tutorial-text {\n    font-size: 1em;\n  }\n\n  .tutorial-arrow {\n    font-size: 1.5em;\n  }\n\n  .tutorial-content {\n    padding: 4px;\n  }\n\n  .tutorial-content button {\n    font-size: 0.8rem;\n    padding: 8px;\n    margin: 8px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
